$(document).ready(function () {
  $('.trigger').click(function () {
    $(this).closest('.triggerWrapper').find('.toggle').slideToggle('slow');
    // トグル矢印を180度回転させる
    $(this).find('.toggle-icon').toggleClass('tw-rotate-180');
  });
});
